export default "__VITE_ASSET__7fb3a857__"